import { render, staticRenderFns } from "./shopSelect.vue?vue&type=template&id=7972d65e&scoped=true"
import script from "./shopSelect.vue?vue&type=script&lang=js"
export * from "./shopSelect.vue?vue&type=script&lang=js"
import style0 from "./shopSelect.vue?vue&type=style&index=0&id=7972d65e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972d65e",
  null
  
)

export default component.exports